import { useEffect, useState } from "react";

// react-bootstrap's Modal fades out over 300ms (backdrop 150ms); a little
// slack so the exit transition finishes before the subtree goes away.
export const MODAL_EXIT_MS = 400;

/*
 * For modals that should mount only while open (so their data hooks don't
 * fire on page load): true as soon as `show` turns on, and still true for the
 * length of the close transition after it turns off, so the modal fades out
 * instead of vanishing. Render as `{mounted && <Modal show={show} />}`.
 */
const useMountWhileOpen = (show: boolean, exitMs = MODAL_EXIT_MS): boolean => {
  const [mounted, setMounted] = useState(show);

  useEffect(() => {
    if (show) {
      setMounted(true);
      return;
    }
    const timeout = setTimeout(() => setMounted(false), exitMs);
    return () => clearTimeout(timeout);
  }, [show, exitMs]);

  return show || mounted;
};

export default useMountWhileOpen;
